import React from "react";
import SidebarComp from "../../components/sidebar/sidebar";
import NavbarComp from "../../components/navbar/navbar";
import AddrideForm from "../../components/body/addride/AddrideForm";
const AddRideScreen=()=>{
    return(
        <div className="container-scroller">
            <NavbarComp />
            <div className="container-fluid page-body-wrapper">
                <SidebarComp />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <AddrideForm />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddRideScreen